/**
 * namespace
 */
export const _prefix = "__text__";

/**
 * 
 * @param {string} txt 
 */
export const getBr = (txt) => {
    return replace(txt, "&lt;br /&gt;", "<br />");
};

/**
 * 
 * @param {string} txt 
 */
export const getRawTags = (txt) => {
    txt = replace(txt, "&lt;", "<");
    txt = replace(txt, "&gt;", ">");
    txt = replace(txt, "&amp;", "&");
    return txt;
};

/**
 * 
 * @param {string} txt 
 * @param {*} pattern 
 * @param {*} replacement 
 * @param {*} option 
 */
export const replace = (txt, pattern, replacement, option) => {
    txt = ""+txt;
    option = option==undefined ? "g" : option; // g | i | gi
    if(pattern.length==0 || pattern==replacement)
        return txt;
    return txt.replace(new RegExp(pattern, option), replacement);
};

/**
 * 
 * @param {string} txt 
 */
export const stripslashes = (txt) => {
    txt = replace(txt, "\\\\", "");
    return txt;
};

/**
 * For the input string, replace the search pattern with the replacement part of map object
 * @param {string} str string to manipulate
 * @param {object} map object of element to replace { replacement part : search pattern}
 * @return {string} return string modify
 */
 export const mapReplace = (str, map = {}) => {
    for (const [replace, pattern] of Object.entries(map)) {
        str = str.replace(new RegExp(pattern, 'g'), replace);
    };
    return str;
};